<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="dates"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        outlined
        dense
        v-model="dateRangeText"
        label="Date Range"
        v-bind="attrs"
        v-on="on"
        readonly
      ></v-text-field>
    </template>
    <v-date-picker ref="picker" v-model="dates" range scrollable>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false">
        Cancel
      </v-btn>
      <v-btn text color="primary" @click="saveDates">
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "DateRangePicker",
  props: ["value"],
  data() {
    return {
      menu: false,
      dates: this.value || []
    };
  },
  computed: {
    dateRangeText() {
      return this.dates && this.dates.length === 2
        ? this.dates.join(" - ")
        : "";
    }
  },
  methods: {
    saveDates() {
      this.$refs.menu.save(this.dates);
      this.$emit("input", this.dates);
    }
  }
};
</script>
